import { ZuiInteractiveIcon } from '@zeiss/zui-react'

export const InteractiveIcon = ({ children, ...props }) => {
    return (
        <ZuiInteractiveIcon emphasis="highlight" {...props}>
            {children}
        </ZuiInteractiveIcon>
    )
}
